module.exports = __webpack_public_path__ + "static/media/Quality.d493ae77.jpg";